import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouteUrl } from './admin/shared/enums/route-url.enum';

const routes: Routes = [

	{
		path: RouteUrl.ADMIN,
		loadChildren: () =>
			import('./admin/admin.module').then(
				(m) => m.AdminModule
			)
	},
	{
		path: '',
		loadChildren: () =>
			import('./public/public.module').then(
				(m) => m.PublicModule
			)
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		relativeLinkResolution: 'legacy',
		scrollPositionRestoration: 'enabled',
		anchorScrolling: 'enabled',
		scrollOffset: [0, 83],
		onSameUrlNavigation: 'reload'
	})],
	exports: [RouterModule]
})
export class AppRoutingModule { }
